<template>
    <div class="emr-lookup-practitioner-modal">

        <!-- emr lookup modal activation button -->
        <b-btn class="btn-secondary ml-2"
               size="sm"
               @click="emrLookupShow($event)">
            {{ $i18n.gt('LABEL_LOOKUP') }}
        </b-btn>

        <!-- modal -->
        <b-modal hide-footer
                 size="xl"
                 :id="modal_id"
                 :title="$i18n.gt('LABEL_EMR_LOOKUP')">

            <data-table ref="dataTable"
                        :show-filters="true"
                        :show-pager="true"
                        :show-details="false"
                        :get-items="getPractitioners"
                        :filters="filters"
                        :fields="fields">

                <!-- custom template for filters -->
                <template v-slot:filters>
                    <b-row cols="2">
                        <b-col>
                            <b-form-group horizontal
                                          :label="$i18n.gt('LABEL_FIRST_NAME')">
                                <b-form-input v-model="filters.firstname.value"
                                              @input="filtersChanged()"/>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group horizontal
                                          :label="$i18n.gt('LABEL_LAST_NAME')">
                                <b-form-input v-model="filters.lastname.value"
                                              @input="filtersChanged()"/>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>

                <!-- template for custom columns -->
                <template v-slot:customField="slotProps">
                    <div v-if="slotProps.row.field.key === 'actions'">
                        <b-btn class="btn btn-ghost-blue btn-sm btn-icon mr-2"
                               @click="selectRecord(slotProps.row.item, false)">
                            {{ $i18n.gt('LABEL_EMR_COPY_IDENTIFIER') }}
                        </b-btn>
                        <b-btn class="btn btn-ghost-blue btn-sm btn-icon mr-2"
                               @click="selectRecord(slotProps.row.item, true)">
                            {{ $i18n.gt('LABEL_EMR_COPY_ALL') }}
                        </b-btn>
                        <b-btn v-if="canDelete"
                               class="btn btn-sm btn-icon mr-2"
                               variant="danger"
                               @click="deleteRecord(slotProps.row.item)">
                            {{ $i18n.gt('LABEL_EMR_DELETE') }}
                        </b-btn>
                    </div>
                </template>
            </data-table>
        </b-modal>
    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'emr-lookup-practitioner-modal',
    props: {
        fieldModel: {type: Object, default: null},
        form: {type: Object, default: null},
        company: {type: Number, default: null},
        practice: {type: Number, default: null},
    },
    data() {
        return {
            modal_id: "emrLookupPractitioner",
            filters: {
                firstname: {field: 'firstname', value: null},
                lastname: {field: 'lastname', value: null},
            },
            canDelete: false,
        }
    },
    computed: {
        fields() {
            return [
                {key: 'firstname', sortable: true, label: this.$i18n.gt('LABEL_FIRST_NAME')},
                {key: 'lastname', sortable: true, label: this.$i18n.gt('LABEL_LAST_NAME')},
                {key: 'actions', sortable: false, custom: true, label: ''},
            ]
        }
    },
    methods: {
        emrLookupShow(e) {
            if (e.shiftKey && this.$user.roleIs('ADMIN')) {
                this.canDelete = true
            }
            if (this.fieldModel && this.fieldModel.fields && this.form) {
                if (this.form['firstname'] && this.form['firstname'].$model) {
                    this.filters.firstname.value = this.form['firstname'].$model
                }
                if (this.form['lastname'] && this.form['lastname'].$model) {
                    this.filters.lastname.value = this.form['lastname'].$model
                }
            }
            this.$bvModal.show('emrLookupPractitioner')
        },
        getPractitioners(listParams) {
            let filters = this.filters;
            filters['type'] = {field: 'type', value: 'practitioner'};
            return this.$api.emrLookup(this, this.filters, listParams, {practice: this.practice, company: this.company})
        },
        filtersChanged() {
            this.$refs.dataTable.debouncedRefresh()
        },
        selectRecord(item, copy) {
            if (this.form['emr_id']) {
                if (this.form && item['emr_id']) {
                    this.form['emr_id'].$model = item['emr_id']
                }
                if (copy) {
                    if (this.form['firstname']) {
                        this.form['firstname'].$model = item.firstname
                    }
                    if (this.form['lastname']) {
                        this.form['lastname'].$model = item.lastname
                    }
                    if (this.form['email']) {
                        this.form['email'].$model = item.email
                    }
                }
            }
            this.$root.$emit('bv::hide::modal', this.modal_id)
        },
        async deleteRecord(item) {
            if (await this.$bvModal.msgBoxConfirm(this.$i18n.gt('LABEL_EMR_CONFIRM_DELETE_PRACTITIONER'))) {
                try {
                    let result = await this.$api.emrDelete(this, 'practitioner', item['emr_id'], this.$user.practitionerPracticeId(), this.company)
                    if (result) {
                        if (result.issue && Array.isArray(result.issue) && result.issue.length) {
                            let issue = result.issue[0]
                            this.$utils.handleError(null, 'Unable to delete EMR record')
                        } else {
                            this.$refs.dataTable.refresh();
                        }
                    }
                } catch (e) {
                    this.$utils.handleError(e, 'Unable to delete EMR record.')
                }
            }
        }
    },
})
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">

.emr-lookup-practitioner-modal {
    display: inline-block;
}

</style>
